var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-select-list d-flex"},_vm._l((_vm.items),function(props,index){return _c('Item',_vm._b({key:index,on:{"click":function($event){return _vm.$emit('select', $event)}}},'Item',props,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }